import { MotifFormField, MotifLabel, MotifOption, MotifSelect } from '@ey-xd/motif-react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const FopQueriesFilter = () => {
  const { fopFilter } = useSelector((state: any) => state.conversations);
  const dispatch = useDispatch();

  return (
    <MotifFormField className="!w-full !mb-0 fop-filter">
      <MotifSelect
        onChange={(val) => {
          dispatch({
            type: 'FOP_FILTER_CHANGE',
            payload: val
          });
        }}
        value={fopFilter}
      >
        <MotifOption value="combined">Global</MotifOption>
        <MotifOption value="americas">Americas</MotifOption>
        <MotifOption value="wincenter">Wincenter</MotifOption>
      </MotifSelect>
    </MotifFormField>
  );
};

export default FopQueriesFilter;
